import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/princemendiratta/Documents/startup/projects/supe/node_modules/next/dist/client/app-dir/link.js");
